'use client';

import {
  FactSlogan,
  freddyTheme,
  GridItem,
  IconButton,
  Input,
  InputAdornment,
  Link as FreddyLink
} from '@coolblue-development/freddy';
import { ArrowRight, Magnifier } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import React, { useState } from 'react';

export const HeroCard = ({ filterPageUrl }: { filterPageUrl: string }) => {
  const { t } = useTranslation('homePage');
  const router = useRouter();

  const [searchValue, setSearchValue] = useState('');
  const [isSearching, setIsSearching] = useState(false);

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!isSearching) {
      setIsSearching(true);
      if (searchValue) {
        const params = new URLSearchParams({ query: searchValue });
        router.push(`${filterPageUrl}?${params}`);
      } else {
        router.push(filterPageUrl);
      }
    }
  };

  return (
    <GridItem
      backgroundColor={freddyTheme.color.background.base}
      padding={{
        xs: freddyTheme.spacing[400],
        md: `${freddyTheme.spacing[400]} ${freddyTheme.spacing[500]}`,
        lg: freddyTheme.spacing[700],
        xl: freddyTheme.spacing[1000]
      }}
      sx={{
        height: '140px',
        [freddyTheme.breakpoint.minWidth('lg')]: {
          gridColumn: '2 / 12',
          height: 'auto',
          zIndex: 1,
          boxShadow: freddyTheme.shadow.strong,
          borderRadius: freddyTheme.borderRadius[200]
        }
      }}
    >
      <FactSlogan
        fact={t('heroCard.fact')}
        slogan={t('heroCard.slogan')}
        size={{
          xs: 'small',
          md: 'medium',
          xl: 'xlarge'
        }}
        sx={{
          paddingBottom: freddyTheme.spacing[400],
          [freddyTheme.breakpoint.minWidth('lg')]: { paddingBottom: freddyTheme.spacing[600] }
        }}
      ></FactSlogan>
      <form onSubmit={onSubmit}>
        <Input
          type='search'
          value={searchValue}
          onChange={e => setSearchValue(e.currentTarget.value)}
          disabled={isSearching}
          endAdornment={
            <InputAdornment>
              <IconButton
                iconColor='inverse'
                aria-label='Search'
                disabled={isSearching}
                sx={{
                  backgroundColor: freddyTheme.color.background.primary,
                  borderRadius: `0 ${freddyTheme.borderRadius[100]} ${freddyTheme.borderRadius[100]} 0`
                }}
              >
                <Magnifier />
              </IconButton>
            </InputAdornment>
          }
          placeholder={t('heroCard.searchPlaceholder')}
        />
      </form>
      <FreddyLink
        component={Link}
        startIcon={<ArrowRight />}
        marginTop={freddyTheme.spacing[400]}
        href={filterPageUrl}
        rel='nofollow'
        onClick={() => setIsSearching(true)}
        aria-label={t('heroCard.allVacanciesLink')}
      >
        {t('heroCard.allVacanciesLink')}
      </FreddyLink>
    </GridItem>
  );
};
